import React, { createContext, useState } from "react";
import { getTranslation } from "./i18n.helper.js";

export const I18nContext = createContext();

export const I8nProvider = ({ children }) => {
    const [selectedLang, setSelectedLang] = useState(() => {
        const stored = localStorage.getItem('lang');
        return stored !== null ? +stored : 1;
    });

    const values = {
        selectedLang: selectedLang,
        setSelectedLang: (lang) => {
            setSelectedLang(lang)
            localStorage.setItem('lang', lang);
        },
        translate: value => getTranslation(value, selectedLang)
    }

    return (<I18nContext.Provider value={values}>{children}</I18nContext.Provider>);
};
